import React, { useState, useEffect, useRef } from "react";
import Header from "../../generalPages/directives/header";
import Footer from "../commanComponents/userfooter";
import config from "../../coreFIles/config";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  Dropdown,
  Modal,
  Form,
} from "react-bootstrap";
import "../commanComponents/componentCSS/propertydetail.css";
import {
  getPropertyDetailAction,
  addWishlistAction,
  removeFromWishlistAction,
  checkBookingDetailsAction,
  getPropertyAvailableDataAction,
  getWishListAction
} from "../../Action/user.action";
import { insertSupportRequestAction } from "../../Action/propertyOwner.action";
import { toast, Toaster } from "react-hot-toast";
import { useParams } from "react-router-dom";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import { AiOutlineHeart, AiFillHeart, AiFillStar } from "react-icons/ai";
import { RxCopy } from "react-icons/rx";
import { Formik } from "formik";
import { AddTicketSchema } from "../../validations/ticket";
import { BsShare, BsWhatsapp, BsStopwatch } from "react-icons/bs";
import "../commanComponents/componentCSS/listingproperty.css";
import { useNavigate } from "react-router-dom";
import Maps from "../Maps";
import DatePicker, { DateObject } from "react-multi-date-picker";
import {
  FaWifi,
  FaUtensils,
  FaSwimmingPool,
  FaChair,
  FaParking,
  FaChargingStation,
  FaDog,
  FaCameraRetro,
  FaBlenderPhone,
  FaNetworkWired,
  FaFan,
  FaHandsWash,
  FaHome,
  FaInfo,
} from "react-icons/fa";
import { LuBadgeCheck } from "react-icons/lu";
import { FaStar } from "react-icons/fa6";
import Cookies from "js-cookie";
import {
  LinkedinShareButton,
  FacebookShareButton,
  WhatsappShareButton,
} from "react-share";
import { AiFillFacebook, AiFillLinkedin, AiFillWechat } from "react-icons/ai";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "../commanComponents/componentCSS/swiper.css";
import { Pagination, Navigation } from "swiper/modules";
const loginData = !Cookies.get("loginSuccessPropertyOwner") ? [] : JSON.parse(Cookies.get("loginSuccessPropertyOwner"));

const PropertyDetails = () => {
  const roomType = useRef(0);
  const selectRoomRef = useRef(null);
  const sortByCatProperty = useRef(0);
  const [show, setShow] = useState(false);
  const [isSelectRoomTypes, setIsSelectRoomTypes] = useState(false);
  const [guestCountPerRoom, setGuestCountPerRoom] = useState(0);
  const [isViewOpen, setisViewOpen] = useState(false);
  const [isViewOpenImages, setisViewOpenImages] = useState(false);
  const [isReviewRatingModel, setReviewRatingModel] = useState(false);
  const [roomTypeImages, setRoomTypeImages] = useState([]);
  const [roomPrice, setRoomPrice] = useState(0);
  // const [roomType, setRoomType] = useState(0);
  const [roomName, setRoomName] = useState('');
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleCloseHost = () => setisHostRequestOpen(false);
  const handleOpenHost = () => setisHostRequestOpen(true);
  const handleOpenview = () => setisViewOpen(true);
  const handleOpenReviewRating = () => setReviewRatingModel(true);
  const handleCloseReviewRating = () => setReviewRatingModel(false);

  const handleCloseview = () => {
    setisViewOpen(false);
    setisViewOpenImages(false);
  }

  const handleOpenviewImages = (imageArr, roomName) => {
    let images = JSON.parse(imageArr.roomsImages)
    setRoomTypeImages(images)
    setisViewOpenImages(true);
    setRoomName(roomName);
  }

  const url = window.location.href;
  
  const urlParams = new URLSearchParams(new URL(url).search);
  const id = urlParams.get("id");
  const numberOfAdults = urlParams.get("numberOfAdults");
  const checkin = urlParams.get("checkin");
  const checkout = urlParams.get("checkout");
  const numberOfChildren = urlParams.get("numberOfChildren");
  const numberOfInfants = urlParams.get("numberOfInfants");
  const numberOfPets = urlParams.get("numberOfPets");
  const propertyPurchaseTypeId = urlParams.get("propertyPurchaseTypeId");

  // const {
  //   id,
  //   numberOfAdults,
  //   checkin,
  //   checkout,
  //   numberOfChildren,
  //   numberOfInfants,
  //   numberOfPets,
  //   propertyPurchaseTypeId,
  // } = useParams();

  const navigate = useNavigate();
  const [cancellationPolicies, setCancellationPolicies] = useState([]);
  const [propertyDetail, setpropertyDetail] = useState({
    PropertyName: "",
    amenityArr: [],
    bikeParking: "",
    carParking: "",
    categoryName: "",
    checkIn: "",
    checkOut: "",
    datetime: "",
    description: "",
    documentArr: [],
    email: "",
    guestCount: "",
    id: "",
    imageArr: [],
    isDeleted: "",
    location: "",
    numberOfBathroom: "",
    numberOfBedrooms: "",
    numberOfBeds: "",
    petsAllowed: "",
    price: "",
    propertyName: "",
    propertyPurchaseType: "",
    propertyPurchaseTypeId: "",
    standoutPropertyAmenity: [],
    status: "",
    terms: "",
    latitude: "",
    longitude: "",
  });
  const [imagesArr, setimagesArr] = useState([]);
  const [safetyHygieneArr, setsafetyHygieneArr] = useState([]);
  const [amenityArr, setAmenityArr] = useState([]);
  const [availableProperty, setAvailableProperty] = useState(0);
  const [guestsCount, setguestCount] = useState({
    adults: 0,
    children: 0,
    infants: 0,
    pets: 0,
  });
  const [leaseCount, setleaseCount] = useState({
    years: 0,
    months: 1,
  });
  const [isHostRequestOpen, setisHostRequestOpen] = useState(false);
  const [wishList, setwishList] = useState([]);
  const [values, setValues] = useState([
    new DateObject().subtract(1, "day"),
    new DateObject().add(1, "day"),
  ]);

  const [bookingDates, setBookingDates] = useState({
    startDate: "",
    endDate: "",
  });
  const [totalBookingDay, settotalBookingDay] = useState(0);
  useEffect(() => {
    getListingDetails();
    getwishList();
    localStorage.clear("PropertDetail");
  }, []);

  const updateGuestCount = async (item, type) => {
    const totalGuests = parseInt(guestsCount.adults) + parseInt(guestsCount.children);
    const maxGuests = parseInt(availableProperty) * parseInt(guestCountPerRoom);

    // Determine the current count for the specific type (adults/children)
    const currentCount = parseInt(guestsCount[type]);

    // Calculate the new count based on the action
    const newCount =
      item === "plus" ? currentCount + 1 : Math.max(currentCount - 1, 0);

    // Prevent exceeding the maximum guest limit on addition
    if (item === "plus" && totalGuests + 1 > maxGuests) return;

    // Update the guest count for the specific type
    setguestCount((old) => ({
      ...old,
      [type]: newCount,
    }));
  };

  useEffect(() => {
    if (values.length > 1) {
      // navigate(`${config.baseUrl}propertydetail/${id}/${numberOfAdults}/${moment(values[0].format()).format("YYYY-MM-DD")}/${moment(values[1].format()).format("YYYY-MM-DD")}/${numberOfChildren}/${numberOfInfants}/${numberOfPets}/${propertyPurchaseTypeId}/0`);

      navigate(`${config.baseUrl}propertydetail?id=${id}&numberOfAdults=${numberOfAdults}&checkin=${moment(values[0].format()).format("YYYY-MM-DD")}&checkout=${moment(values[1].format()).format("YYYY-MM-DD")}&numberOfChildren=${numberOfChildren}&numberOfInfants=${numberOfInfants}&numberOfPets=${numberOfPets}&propertyPurchaseTypeId=${propertyPurchaseTypeId}&roomType=0`);

      getPropertyAvailableData(moment(values[0].format()).format("YYYY-MM-DD"), moment(values[1].format()).format("YYYY-MM-DD"))
    }
  }, [values]);

  const getPropertyAvailableData = async (check_in_date, check_out_date) => {
    let res = await getPropertyAvailableDataAction({ id: id, checkInDate: check_in_date, checkOutDate: check_out_date, roomType: roomType.current });
    if (res.success) {
      setAvailableProperty(res.data[0].availableProperty)
    }
  }

  const getListingDetails = async () => {
    let res = await getPropertyDetailAction({ id: id, checkInDate: checkin, checkOutDate: checkout, roomType: roomType.current });
    if (res.success) {
      setAvailableProperty(res.data.availableProperty)
      setpropertyDetail(res.data);
      setGuestCountPerRoom(res.data.guestCount)
      setRoomPrice(res.data?.price)
      setCancellationPolicies(res.data.cancellationPolicies);
      setimagesArr(JSON.parse(res.data.imageArr));
      setAmenityArr(res.data.amenityArr);
      setsafetyHygieneArr(res.data.safetyHygieneArr);
    }
    if (checkin && checkout) {
      setBookingDates((old) => {
        return { ...old, ["startDate"]: checkin, ["endDate"]: checkout };
      });
      setValues([new DateObject(checkin), new DateObject(checkout)]);
      //Difference in number of days
      var date1 = new Date(checkin);
      var date2 = new Date(checkout);

      // To calculate the time difference of two dates
      var Difference_In_Time = date2.getTime() - date1.getTime();

      // To calculate the no. of days between two dates
      var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

      settotalBookingDay(Difference_In_Days);
      setguestCount({
        adults: numberOfAdults,
        children: numberOfChildren,
        infants: numberOfInfants,
        pets: numberOfPets,
      });
    }
  };

  const getwishList = async () => {
    if (loginData?.id) {
      let res = await getWishListAction({});
      if (res.success) {
        setwishList(res.data.getWishList);
      } else {
        setwishList([]);
      }
    }
  };

  const createMarkup = () => {
    return { __html: propertyDetail.description };
  };

  useEffect(() => {
    if (values[0].format()) {
      setBookingDates((old) => {
        return { ...old, ["startDate"]: values[0].format() };
      });
    }

    if (values.length > 1) {
      setBookingDates((old) => {
        return {
          ...old,
          ["endDate"]:
            values[0].format() == values[1].format()
              ? values[1].add(1, "day").format()
              : values[1].format(),
        };
      });
      var start = moment(values[0].format(), "YYYY-MM-DD");
      var end = moment(values[1].format(), "YYYY-MM-DD");

      //Difference in number of days
      const dif = moment.duration(start.diff(end)).asDays();
      settotalBookingDay(dif * -1);
    }
  }, [values]);

  const bookHandler1 = async () => {

    if (loginData.length == 0) {

      // localStorage.setItem(
      //   "PropertDetail",
      //   `${config.baseUrl}propertydetail/${id}/${guestsCount.adults}/${moment(
      //     bookingDates.startDate
      //   ).format("YYYY-MM-DD")}/${moment(bookingDates.endDate).format(
      //     "YYYY-MM-DD"
      //   )}/${guestsCount.children}/${guestsCount.infants}/${guestsCount.pets
      //   }/${propertyPurchaseTypeId}/${roomType.current}`
      // );

      localStorage.setItem("PropertDetail", `${config.baseUrl}propertydetail?id=${id}&propertyPurchaseTypeId=${propertyPurchaseTypeId}&numberOfAdults=${guestsCount.adults}&checkin=${moment(bookingDates.startDate).format("YYYY-MM-DD")}&checkout=${moment(bookingDates.endDate).format("YYYY-MM-DD")}&numberOfChildren=${guestsCount.children}&numberOfInfants=${guestsCount.infants}&numberOfPets=${guestsCount.pets}&roomType=${roomType.current}`
      );

      window.location.href = `${config.baseUrl}userlogin`;
    } else {

      let arr = {
        propertyId: parseInt(id),
        paymentMethodId: 1,
        propertyPurchaseTypeId: parseInt(propertyPurchaseTypeId),
        numberOfAdults: 1,
        numberOfChildren: parseInt(guestsCount.children),
        checkInDate: bookingDates.startDate,
        checkOutDate: bookingDates.endDate,
        cardNumber: "",
        expiryDate: "",
        accountNumber: "",
        amount: 0,
        ifscCode: "",
        upiId: "",
        roomType: 0
      };

      let result = await checkBookingDetailsAction(arr);
      if (result.success) {
        // navigate(
        //   `${config.baseUrl}payment/${id}/${propertyPurchaseTypeId == 3
        //     ? parseInt(
        //       leaseCount[propertyDetail.priceType ? "years" : "months"]
        //     )
        //     : parseInt(guestsCount.adults)
        //   }/${moment(bookingDates.startDate).format("YYYY-MM-DD")}/${moment(
        //     bookingDates.endDate
        //   ).format("YYYY-MM-DD")}/${guestsCount.children}/${guestsCount.infants
        //   }/${guestsCount.pets}/${roomType.current}`
        // );

        navigate(
          `${config.baseUrl}payment?id=${id}&numberOfAdults=${propertyPurchaseTypeId == 3 ? parseInt(leaseCount[propertyDetail.priceType ? "years" : "months"]) : parseInt(guestsCount.adults)}&checkin=${moment(bookingDates.startDate).format("YYYY-MM-DD")}&checkout=${moment(bookingDates.endDate).format("YYYY-MM-DD")}&numberOfChildren=${guestsCount.children}&numberOfInfants=${guestsCount.infants}&numberOfPets=${guestsCount.pets}&roomType=${roomType.current}`
        );

      } else {
        toast.error(result.msg);
      }
    }
  };

  const bookHandler = async () => {

    if (isSelectRoomTypes == false && propertyPurchaseTypeId == 2) {
      toast.error('Please select room type.');
      return;
    }

    if (loginData.length == 0) {
      // localStorage.setItem(
      //   "PropertDetail",
      //   `${config.baseUrl}propertydetail/${id}/${guestsCount.adults}/${moment(
      //     bookingDates.startDate
      //   ).format("YYYY-MM-DD")}/${moment(bookingDates.endDate).format(
      //     "YYYY-MM-DD"
      //   )}/${guestsCount.children}/${guestsCount.infants}/${guestsCount.pets
      //   }/${propertyPurchaseTypeId}/${roomType.current}`
      // );

      localStorage.setItem("PropertDetail", `${config.baseUrl}propertydetail?id=${id}&numberOfAdults=${guestsCount.adults}&checkin=${moment(bookingDates.startDate).format("YYYY-MM-DD")}&checkout=${moment(bookingDates.endDate).format("YYYY-MM-DD")}&numberOfChildren=${guestsCount.children}&numberOfInfants=${guestsCount.infants}&numberOfPets=${guestsCount.pets}&propertyPurchaseTypeId=${propertyPurchaseTypeId}&roomType=${roomType.current}`
      );

      window.location.href = `${config.baseUrl}userlogin`;
    } else {
      if (((parseInt(guestsCount.adults) + parseInt(guestsCount.children)) > (parseInt(availableProperty) * parseInt(guestCountPerRoom))) && propertyPurchaseTypeId == 2) {
        toast.error('Standard rooms are fully booked. Please select a different room type.');
      } else if (parseInt(guestsCount.adults) <= 0 && propertyPurchaseTypeId == 2) {
        toast.error('Please select guest.');
      } else {

        // navigate(
        //   `${config.baseUrl}payment/${id}/${propertyPurchaseTypeId == 3
        //     ? parseInt(
        //       leaseCount[propertyDetail.priceType ? "years" : "months"]
        //     )
        //     : parseInt(guestsCount.adults)
        //   }/${moment(bookingDates.startDate).format("YYYY-MM-DD")}/${moment(
        //     bookingDates.endDate
        //   ).format("YYYY-MM-DD")}/${guestsCount.children}/${guestsCount.infants
        //   }/${guestsCount.pets}/${roomType.current}`
        // );

        navigate(
          `${config.baseUrl}payment?id=${id}&numberOfAdults=${propertyPurchaseTypeId == 3 ? parseInt(leaseCount[propertyDetail.priceType ? "years" : "months"]) : parseInt(guestsCount.adults)}&checkin=${moment(bookingDates.startDate).format("YYYY-MM-DD")}&checkout=${moment(bookingDates.endDate).format("YYYY-MM-DD")}&numberOfChildren=${guestsCount.children}&numberOfInfants=${guestsCount.infants}&numberOfPets=${guestsCount.pets}&roomType=${roomType.current}`
        );
      }
    }
  };

  const addToWishList = async (e, id, type, status) => {
    if (loginData?.id) {
      let res =
        status == 1
          ? await addWishlistAction({ id: id, type: type })
          : await removeFromWishlistAction({ id: id, type: type });
      if (res.success) {
        toast.success(res.msg);
        getListingDetails();
        getwishList();
      } else {
        toast.error(res.msg);
      }
    } else {
      toast.error("You can add properties to your wishlist after logging in.")
      getwishList();
    };
  }
  const formSubmit = async (data) => {
    data.propertyId = id;
    data.type = 2;
    data.ticketType = 1;
    data.touserId = propertyDetail?.ownerId;

    if (loginData?.id) {
      let res = await insertSupportRequestAction(data);
      if (res.success) {
        toast.success(res.msg);
        setisHostRequestOpen(false);
      } else {
        toast.error(res.msg);
      }
    } else {
      toast.error("You must be logged in first!")
    };
  }

  const createMarkupTerms = () => {
    return { __html: propertyDetail.terms };
  };

  const copyText = () => {
    toast.success("Copied!");
    navigator.clipboard.writeText(window.location);
  };
  const selectedLocation = {
    lat: propertyDetail.latitude,
    lng: propertyDetail.longitude,
    location: propertyDetail.location,
  };

  const selectRoomType = (price, type, personsAllowed) => {
    setIsSelectRoomTypes(true);
    setguestCount((old) => {
      return {
        ...old,
        ["adults"]: 0,
        ["children"]: 0
      };
    });
    setGuestCountPerRoom(personsAllowed)
    if (roomType.current == type) {
      setRoomPrice(propertyDetail?.price);
      roomType.current = 0
      setIsSelectRoomTypes(false);
      getPropertyAvailableData(moment(bookingDates.startDate).format("YYYY-MM-DD"), moment(bookingDates.endDate).format("YYYY-MM-DD"))
    } else {
      selectRoomRef.current?.scrollIntoView({ behavior: 'smooth' });
      setRoomPrice(price);
      roomType.current = type
      getPropertyAvailableData(moment(bookingDates.startDate).format("YYYY-MM-DD"), moment(bookingDates.endDate).format("YYYY-MM-DD"))
    }

  }

  return (
    <>
      <Header />
      <section className="propertydetail  pt-0 pb-0 overflow-hidden">
        <Container className="mt-5">
          <Toaster />
          <Row className="align-items-center">
            <Col lg={6}>
              <h3>
                <b>{propertyDetail.propertyName}</b>
              </h3>
              <p className="mb-0">{propertyDetail.location}</p>
            </Col>

            <Col lg={6} className="text-right">
              <div className="socialicon">
                <span className="me-3">
                  <AiFillStar fill="#E46422" width="20px" /> &nbsp;
                  {parseFloat(propertyDetail?.rating).toFixed(1)}
                </span>
                <span className="me-3">
                  {wishList.length > 0 &&
                    wishList.find(
                      (wishitem) =>
                        wishitem.propertyId == propertyDetail.id &&
                        wishitem.status == 1 &&
                        wishitem.userId == loginData?.id
                    ) ? (
                    <AiFillHeart
                      width="20px"
                      fill="#D8000C"
                      onClick={(e) => addToWishList(e, propertyDetail.id, 1, 0)}
                    />
                  ) : (
                    <AiOutlineHeart
                      width="20px"
                      fill="#D8000C"
                      AiOutlineHeart
                      onClick={(e) => addToWishList(e, propertyDetail.id, 1, 1)}
                    />
                  )}
                </span>
                <span>
                  <Button
                    variant="transparent"
                    className="border-0 "
                    onClick={handleShow}
                  >
                    {" "}
                    <BsShare />
                  </Button>
                  <Modal show={show} onHide={handleClose} size="md">
                    <Modal.Header closeButton>
                      <Modal.Title>
                        <b>Share this place</b>
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <div className="d-flex align-items-center">
                        <div className="me-2">

                          {imagesArr.length > 0 ? (
                            <img
                              src={imagesArr[0].fileNameImage}
                              alt=""
                              height={`62px`}
                              width={`100px`}
                              className="object-fit-contain rounded-2"
                            />
                          ) : (
                            <img
                              src="assets/images/property2.svg"
                              alt=""
                              height={`62px`}
                              width={`100px`}
                              className="object-fit-contain rounded-2"
                            />
                          )}
                        </div>
                        <div>
                          <p className="mb-0">
                            {propertyDetail.propertyName} in{" "}
                            {propertyDetail.location} ·{" "}
                            {propertyDetail.numberOfBedrooms} bedroom ·{" "}
                            {propertyDetail.numberOfBathroom} private bathroom
                          </p>
                        </div>
                      </div>
                      <div>
                        <br />
                        <Row>
                          <Col lg={6} className="mb-3">
                            <Button
                              variant="transparent"
                              className="rounded-3 w-100 border-1 border-secondary"
                              onClick={(e) => copyText(e)}
                            >
                              <RxCopy size={23} fill="#E46422" />
                              &nbsp; Copy Link
                            </Button>
                          </Col>
                          <Col lg={6} className="mb-3">
                            <Button
                              variant="transparent"
                              className="rounded-3 w-100 border-1 border-secondary"
                            >
                              <LinkedinShareButton
                                url={url}
                                title="Check out this iHateReading custom repository "
                              >
                                <AiFillLinkedin fill="#0072b1" size={23} />
                                &nbsp; Linkedin
                              </LinkedinShareButton>
                            </Button>
                          </Col>

                          <Col lg={6} className="mb-3">
                            <Button
                              variant="transparent"
                              className="rounded-3 w-100 border-1 border-secondary"
                            >
                              <WhatsappShareButton
                                url={url}
                                title="Check out this iHateReading custom repository "
                              >
                                <BsWhatsapp fill="#25d366" size={23} />
                                &nbsp; Whatsapp
                              </WhatsappShareButton>
                            </Button>
                          </Col>
                          <Col lg={6} className="mb-3">
                            <Button
                              variant="transparent"
                              className="rounded-3 w-100 border-1 border-secondary"
                            >
                              <FacebookShareButton
                                url={url}
                                title="Check out this iHateReading custom repository "
                              >
                                <AiFillFacebook fill="#1877F2" size={23} />{" "}
                                Facebook
                              </FacebookShareButton>
                            </Button>
                          </Col>
                        </Row>
                      </div>
                    </Modal.Body>
                  </Modal>
                  <div className="d-none">
                    <WhatsappShareButton
                      url={url}
                      title="Check out this iHateReading custom repository "
                    >
                      <AiFillWechat style={{ opacity: "0.5" }} size={18} />
                    </WhatsappShareButton>
                    <FacebookShareButton
                      url={url}
                      title="Check out this iHateReading custom repository "
                    >
                      <AiFillFacebook style={{ opacity: "0.5" }} size={18} />
                    </FacebookShareButton>
                  </div>
                </span>
              </div>
              <div>
                {propertyDetail?.categoryName}
              </div>
            </Col>
          </Row>
        </Container>
        <Container className="mt-3">
          <Row>
            <Col lg={6} className="px-1 mb-2">
              <div className="propertydetailImg">
                {imagesArr.length > 0 ? (
                  <img
                    src={imagesArr[0].fileNameImage}
                  />
                ) : (
                  <img src={"assets/images/no-image.avif"} />
                )}
              </div>
            </Col>
            <Col lg={6} className="text-right px-1 mb-4">
              <div className="collapsImg">
                <div className="nft_pic nft_multi">
                  <a className="">
                    {imagesArr.length > 1 ? (
                      <img
                        src={imagesArr[1].fileNameImage}
                      />
                    ) : (
                      <img
                        src={"assets/images/no-image.avif"}
                        style={{ background: "#eee", objectFit: "contain" }}
                      />
                    )}
                  </a>
                  <a className="">
                    {imagesArr.length > 2 ? (
                      <img
                        src={imagesArr[2].fileNameImage}
                      />
                    ) : (
                      <img
                        src={"assets/images/no-image.avif"}
                        style={{ background: "#eee", objectFit: "contain" }}
                      />
                    )}
                  </a>
                  <a className="">
                    {imagesArr.length > 3 ? (
                      <img
                        src={imagesArr[3].fileNameImage}
                      />
                    ) : (
                      <img
                        src={"assets/images/no-image.avif"}
                        style={{ background: "#eee", objectFit: "contain" }}
                      />
                    )}
                  </a>
                  <a className="">
                    {imagesArr.length > 4 ? (
                      <img
                        src={imagesArr[4].fileNameImage}
                      />
                    ) : (
                      <img
                        src={"assets/images/no-image.avif"}
                        style={{ background: "#eee", objectFit: "contain" }}
                      />
                    )}
                    {imagesArr.length > 5 ? (
                      <Button
                        variant="default"
                        className="viewmore position-absolute rounded-2 btn-sm h-auto text-white border"
                        onClick={handleOpenview}
                      >
                        View More
                      </Button>
                    ) : (
                      ""
                    )}
                  </a>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
        <div className=" mb-4" ref={selectRoomRef}>
          <Container>
            <Row>
              <Col lg={8}>
                <div className="amenities_list mb-5">
                  {propertyDetail.propertyPurchaseTypeId == 2 ? (
                    <Row>
                      <Col lg={3} md={4} xs={6} className="amenitiesBox">
                        <div className="text-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="43"
                            height="32"
                            viewBox="0 0 43 32"
                            fill="none"
                          >
                            <path
                              d="M5.87207 4.81061C5.87207 4.06519 6.1781 3.3503 6.72283 2.82321C7.26756 2.29612 8.00637 2 8.77674 2H33.9505C34.7209 2 35.4597 2.29612 36.0044 2.82321C36.5491 3.3503 36.8552 4.06519 36.8552 4.81061V15.1162H5.87207V4.81061Z"
                              stroke="#E46422"
                              stroke-width="3"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M3.93652 26.3586V30.1061"
                              stroke="#E46422"
                              stroke-width="3"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M38.792 26.3586V30.1061"
                              stroke="#E46422"
                              stroke-width="3"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M26.206 10.4316H16.5238C15.7534 10.4316 15.0146 10.7278 14.4699 11.2549C13.9252 11.7819 13.6191 12.4968 13.6191 13.2423V15.116H29.1107V13.2423C29.1107 12.4968 28.8047 11.7819 28.2599 11.2549C27.7152 10.7278 26.9764 10.4316 26.206 10.4316Z"
                              stroke="#E46422"
                              stroke-width="3"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M2 17.9268C2 17.1814 2.30603 16.4665 2.85076 15.9394C3.39549 15.4123 4.1343 15.1162 4.90466 15.1162H37.8242C38.5946 15.1162 39.3334 15.4123 39.8781 15.9394C40.4228 16.4665 40.7289 17.1814 40.7289 17.9268V26.3587H2V17.9268Z"
                              stroke="#E46422"
                              stroke-width="3"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <p className="mt-2">
                            {propertyDetail.guestCount} Guests/Total Occupancy
                          </p>
                        </div>
                      </Col>
                      <Col lg={3} md={4} xs={6} className="amenitiesBox">
                        <div className="text-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="37"
                            height="30"
                            viewBox="0 0 37 30"
                            fill="none"
                          >
                            <path
                              d="M2 12.26L5.57674 4.18484C6.15897 2.87027 7.6425 2 9.30022 2H28.0246C29.6823 2 31.1658 2.87027 31.7481 4.18484L35.3248 12.26"
                              stroke="#E46422"
                              stroke-width="3"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M2 12.26H35.3248V25.4515H2V12.26Z"
                              stroke="#E46422"
                              stroke-width="3"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M5.02953 25.4514V28.3829H2V25.4514"
                              stroke="#E46422"
                              stroke-width="3"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M35.3245 25.4514V28.3829H32.2949V25.4514"
                              stroke="#E46422"
                              stroke-width="3"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M8.05871 19.5887C8.89529 19.5887 9.57347 18.9324 9.57347 18.1229C9.57347 17.3135 8.89529 16.6572 8.05871 16.6572C7.22213 16.6572 6.54395 17.3135 6.54395 18.1229C6.54395 18.9324 7.22213 19.5887 8.05871 19.5887Z"
                              stroke="#E46422"
                              stroke-width="3"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M29.2657 19.5887C30.1023 19.5887 30.7805 18.9324 30.7805 18.1229C30.7805 17.3135 30.1023 16.6572 29.2657 16.6572C28.4292 16.6572 27.751 17.3135 27.751 18.1229C27.751 18.9324 28.4292 19.5887 29.2657 19.5887Z"
                              stroke="#E46422"
                              stroke-width="3"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <p className="mt-2">
                            {propertyDetail.carParking} Cars/
                            {propertyDetail.bikeParking} Bikes
                          </p>
                        </div>
                      </Col>
                      <Col lg={3} md={4} xs={6} className="amenitiesBox">
                        <div className="text-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="38"
                            height="38"
                            viewBox="0 0 38 38"
                            fill="none"
                          >
                            <circle
                              cx="19"
                              cy="19"
                              r="17"
                              stroke="#E46422"
                              stroke-width="3"
                            />
                            <path
                              d="M19 12.2V18.7324C19 18.8995 19.0836 19.0557 19.2226 19.1484L24.1 22.4"
                              stroke="#E46422"
                              stroke-width="3"
                              stroke-linecap="round"
                            />
                          </svg>
                          <p className="mt-2">
                            {propertyDetail.checkIn}{" "}
                            {parseInt(propertyDetail.checkIn) < 12 ? "AM" : "PM"}{" "}
                            to {propertyDetail.checkOut}{" "}
                            {parseInt(propertyDetail.checkOut) < 12 ? "AM" : "PM"}
                          </p>
                        </div>
                      </Col>
                      <Col lg={3} md={4} xs={6} className="">
                        <div className="text-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="39"
                            height="33"
                            viewBox="0 0 39 33"
                            fill="none"
                          >
                            <path
                              d="M35.7014 10.1269C35.4201 10.0198 35.1203 9.96527 34.818 9.96607H34.7863C33.1897 9.98905 31.3991 11.436 30.4594 13.6244C29.333 16.2425 29.8515 18.9211 31.6263 19.6097C31.9073 19.7168 32.2068 19.7713 32.5089 19.7705C34.1135 19.7705 35.9286 18.3152 36.8762 16.1123C37.9947 13.4942 37.4683 10.8155 35.7014 10.1269V10.1269Z"
                              stroke="#E46422"
                              stroke-width="3"
                              stroke-miterlimit="10"
                            />
                            <path
                              d="M25.4003 20.3436C23.1996 16.8102 22.2497 15.4812 19.7324 15.4812C17.2151 15.4812 16.2572 16.8186 14.0566 20.3436C12.1726 23.3585 8.36494 23.6097 7.41501 26.1704C7.2223 26.6394 7.12551 27.1402 7.13003 27.6449C7.13003 29.7276 8.77657 31.4135 10.8031 31.4135C13.3204 31.4135 16.748 29.4687 19.7403 29.4687C22.7326 29.4687 26.1444 31.4135 28.6617 31.4135C30.6882 31.4135 32.3268 29.7283 32.3268 27.6449C32.3287 27.1397 32.2292 26.6389 32.0339 26.1704C31.084 23.6005 27.2843 23.3585 25.4003 20.3436Z"
                              stroke="#E46422"
                              stroke-width="3"
                              stroke-miterlimit="10"
                            />
                            <path
                              d="M14.7056 12.1109C14.8116 12.1109 14.9174 12.1033 15.0222 12.0879C16.8596 11.8297 18.0066 9.36637 17.5902 6.58436C17.1984 3.96166 15.5534 2 13.8333 2C13.7273 1.99992 13.6214 2.0076 13.5166 2.02298C11.6793 2.28111 10.5323 4.74449 10.9486 7.5265C11.3405 10.1415 12.9854 12.1109 14.7056 12.1109Z"
                              stroke="#E46422"
                              stroke-width="3"
                              stroke-miterlimit="10"
                            />
                            <path
                              d="M28.5126 7.5265C28.929 4.74449 27.782 2.28111 25.9447 2.02298C25.8399 2.0076 25.734 1.99992 25.628 2C23.9079 2 22.2661 3.96166 21.8734 6.58436C21.4571 9.36637 22.6041 11.8297 24.4414 12.0879C24.5462 12.1033 24.6521 12.1109 24.7581 12.1109C26.4782 12.1109 28.1232 10.1415 28.5126 7.5265V7.5265Z"
                              stroke="#E46422"
                              stroke-width="3"
                              stroke-miterlimit="10"
                            />
                            <path
                              d="M7.83953 19.6097C9.61193 18.9203 10.1296 16.2394 9.00477 13.6244C8.05801 11.4214 6.24444 9.96607 4.64223 9.96607C4.34016 9.96527 4.04067 10.0199 3.75959 10.1269C1.98719 10.8163 1.46948 13.4972 2.59435 16.1123C3.54111 18.3152 5.35468 19.7705 6.95689 19.7705C7.25896 19.7713 7.55846 19.7168 7.83953 19.6097V19.6097Z"
                              stroke="#E46422"
                              stroke-width="3"
                              stroke-miterlimit="10"
                            />
                          </svg>
                          <p className="mt-2">
                            {propertyDetail?.petsAllowed
                              ? "Pets Allowed"
                              : "No pets Allowed"}{" "}
                          </p>
                        </div>
                      </Col>
                    </Row>) : ""}
                </div>
                <Col lg={12} className="mb-5">
                  <div>
                    <h5 className="mb-3">
                      <b>Property Description</b>
                    </h5>
                    <p className="text-grey">
                      <div dangerouslySetInnerHTML={createMarkup()} />
                    </p>
                  </div>
                </Col>

                <Col lg={12} className="mb-5">
                  {propertyDetail.terms == "" ||
                    propertyDetail.terms == null ||
                    propertyDetail.terms == undefined ? (
                    ""
                  ) : (
                    <div>
                      <h5 className="mb-3">
                        <b>Property Policies</b>
                      </h5>
                      <Row>
                        <Col lg={6} className="mb-2">
                          <p className="text-grey">
                            <div
                              dangerouslySetInnerHTML={createMarkupTerms()}
                            />
                          </p>
                        </Col>
                      </Row>
                    </div>
                  )}
                </Col>

                <Col lg={12} className="mb-5">
                  {amenityArr == "" ||
                    amenityArr == null ||
                    amenityArr == undefined ||
                    amenityArr == [] ? (
                    ""
                  ) : (
                    <div>
                      <h5 className="mb-3">
                        <b>Offered Amenities</b>
                      </h5>
                      <Row>
                        {amenityArr.length > 0
                          ? amenityArr.map((data) => (
                            <Col lg={4}>
                              <div className="">
                                <p>
                                  {data.icon == "wifi" ? (
                                    <FaWifi />
                                  ) : data.icon == "Workspace" ? (
                                    <FaChair />
                                  ) : data.icon == "Parking" ? (
                                    <FaParking />
                                  ) : data.icon == "Pool" ? (
                                    <FaSwimmingPool />
                                  ) : data.icon == "Charger" ? (
                                    <FaChargingStation />
                                  ) : data.icon == "Pets" ? (
                                    <FaDog />
                                  ) : data.icon == "Cameras" ? (
                                    <FaCameraRetro />
                                  ) : data.icon == "Kitchen" ? (
                                    <FaUtensils />
                                  ) : data.icon == "Television" ? (
                                    <FaBlenderPhone />
                                  ) : data.icon == "Internet" ? (
                                    <FaNetworkWired />
                                  ) : data.icon == "ac" ? (
                                    <FaFan />
                                  ) : data.icon == "Washer" ? (
                                    <FaHandsWash />
                                  ) : data.icon == "Balcony" ? (
                                    <FaHome />
                                  ) : (
                                    <LuBadgeCheck />
                                  )}
                                  &nbsp;{data.name}
                                </p>
                              </div>
                            </Col>
                          ))
                          : ""}
                      </Row>
                    </div>
                  )}
                </Col>
                {propertyDetail.standoutPropertyAmenity.length > 0 ? (
                  <Col lg={12} className="mb-5">

                    <div>
                      <h5 className="mb-3">
                        <b>Standout Aminities</b>
                      </h5>
                      <Row>
                        {propertyDetail.standoutPropertyAmenity.length > 0 ? (
                          propertyDetail.standoutPropertyAmenity.map((item) => {
                            return (
                              <Col lg={6} className="mb-2">
                                <div>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="27"
                                    height="33"
                                    viewBox="0 0 27 33"
                                    fill="none"
                                  >
                                    <path
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M7.75 2.75C7.20299 2.75 6.67839 2.9673 6.29159 3.35409C5.9048 3.74089 5.6875 4.26549 5.6875 4.8125H3.625C3.07799 4.8125 2.55339 5.0298 2.16659 5.41659C1.7798 5.80339 1.5625 6.32799 1.5625 6.875V26.125C1.5625 26.672 1.7798 27.1966 2.16659 27.5834C2.55339 27.9702 3.07799 28.1875 3.625 28.1875H11.875V26.8125H3.625C3.44266 26.8125 3.2678 26.7401 3.13886 26.6111C3.00993 26.4822 2.9375 26.3073 2.9375 26.125V6.875C2.9375 6.69266 3.00993 6.5178 3.13886 6.38886C3.2678 6.25993 3.44266 6.1875 3.625 6.1875H5.6875C5.6875 6.73451 5.9048 7.25911 6.29159 7.64591C6.67839 8.0327 7.20299 8.25 7.75 8.25H13.25C13.797 8.25 14.3216 8.0327 14.7084 7.64591C15.0952 7.25911 15.3125 6.73451 15.3125 6.1875H17.375C17.5573 6.1875 17.7322 6.25993 17.8611 6.38886C17.9901 6.5178 18.0625 6.69266 18.0625 6.875V17.1875H19.4375V6.875C19.4375 6.32799 19.2202 5.80339 18.8334 5.41659C18.4466 5.0298 17.922 4.8125 17.375 4.8125H15.3125C15.3125 4.26549 15.0952 3.74089 14.7084 3.35409C14.3216 2.9673 13.797 2.75 13.25 2.75H7.75ZM7.0625 4.8125C7.0625 4.63016 7.13493 4.4553 7.26386 4.32636C7.39279 4.19743 7.56766 4.125 7.75 4.125H13.25C13.4323 4.125 13.6072 4.19743 13.7361 4.32636C13.8651 4.4553 13.9375 4.63016 13.9375 4.8125V6.1875C13.9375 6.36984 13.8651 6.5447 13.7361 6.67364C13.6072 6.80257 13.4323 6.875 13.25 6.875H7.75C7.56766 6.875 7.39279 6.80257 7.26386 6.67364C7.13493 6.5447 7.0625 6.36984 7.0625 6.1875V4.8125ZM9.8125 13.0625V11H11.1875V13.0625H13.25V14.4375H11.1875V16.5H9.8125V14.4375H7.75V13.0625H9.8125ZM12.5625 19.25C12.5625 19.0677 12.6349 18.8928 12.7639 18.7639C12.8928 18.6349 13.0677 18.5625 13.25 18.5625H21.5C21.6823 18.5625 21.8572 18.6349 21.9861 18.7639C22.1151 18.8928 22.1875 19.0677 22.1875 19.25V23.9174C22.1875 24.7097 21.9919 25.4896 21.618 26.1881C21.2442 26.8866 20.7037 27.482 20.0446 27.9214L17.7566 29.4477C17.6436 29.5231 17.5108 29.5633 17.375 29.5633C17.2392 29.5633 17.1064 29.5231 16.9934 29.4477L14.7054 27.9214C14.0464 27.482 13.506 26.8868 13.1321 26.1884C12.7583 25.4901 12.5626 24.7102 12.5625 23.9181V19.25ZM13.9375 19.9375V23.9174C13.9376 24.4833 14.0773 25.0405 14.3444 25.5394C14.6115 26.0383 14.9977 26.4636 15.4686 26.7774L17.375 28.05L19.2814 26.7781C19.7523 26.4643 20.1385 26.039 20.4056 25.5401C20.6727 25.0412 20.8124 24.484 20.8125 23.9181V19.9375H13.9375ZM17.1736 25.2361L19.9236 22.4861L18.9514 21.5139L16.6875 23.7779L15.7986 22.8889L14.8264 23.8611L16.2014 25.2361C16.3304 25.3649 16.5052 25.4374 16.6875 25.4374C16.8698 25.4374 17.0446 25.3649 17.1736 25.2361Z"
                                      fill="black"
                                    />
                                  </svg>
                                  &nbsp;{item.name}
                                </div>
                              </Col>
                            );
                          })
                        ) : (
                          <Col lg={6} className="mb-2">
                            <div>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="27"
                                height="33"
                                viewBox="0 0 27 33"
                                fill="none"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M7.75 2.75C7.20299 2.75 6.67839 2.9673 6.29159 3.35409C5.9048 3.74089 5.6875 4.26549 5.6875 4.8125H3.625C3.07799 4.8125 2.55339 5.0298 2.16659 5.41659C1.7798 5.80339 1.5625 6.32799 1.5625 6.875V26.125C1.5625 26.672 1.7798 27.1966 2.16659 27.5834C2.55339 27.9702 3.07799 28.1875 3.625 28.1875H11.875V26.8125H3.625C3.44266 26.8125 3.2678 26.7401 3.13886 26.6111C3.00993 26.4822 2.9375 26.3073 2.9375 26.125V6.875C2.9375 6.69266 3.00993 6.5178 3.13886 6.38886C3.2678 6.25993 3.44266 6.1875 3.625 6.1875H5.6875C5.6875 6.73451 5.9048 7.25911 6.29159 7.64591C6.67839 8.0327 7.20299 8.25 7.75 8.25H13.25C13.797 8.25 14.3216 8.0327 14.7084 7.64591C15.0952 7.25911 15.3125 6.73451 15.3125 6.1875H17.375C17.5573 6.1875 17.7322 6.25993 17.8611 6.38886C17.9901 6.5178 18.0625 6.69266 18.0625 6.875V17.1875H19.4375V6.875C19.4375 6.32799 19.2202 5.80339 18.8334 5.41659C18.4466 5.0298 17.922 4.8125 17.375 4.8125H15.3125C15.3125 4.26549 15.0952 3.74089 14.7084 3.35409C14.3216 2.9673 13.797 2.75 13.25 2.75H7.75ZM7.0625 4.8125C7.0625 4.63016 7.13493 4.4553 7.26386 4.32636C7.39279 4.19743 7.56766 4.125 7.75 4.125H13.25C13.4323 4.125 13.6072 4.19743 13.7361 4.32636C13.8651 4.4553 13.9375 4.63016 13.9375 4.8125V6.1875C13.9375 6.36984 13.8651 6.5447 13.7361 6.67364C13.6072 6.80257 13.4323 6.875 13.25 6.875H7.75C7.56766 6.875 7.39279 6.80257 7.26386 6.67364C7.13493 6.5447 7.0625 6.36984 7.0625 6.1875V4.8125ZM9.8125 13.0625V11H11.1875V13.0625H13.25V14.4375H11.1875V16.5H9.8125V14.4375H7.75V13.0625H9.8125ZM12.5625 19.25C12.5625 19.0677 12.6349 18.8928 12.7639 18.7639C12.8928 18.6349 13.0677 18.5625 13.25 18.5625H21.5C21.6823 18.5625 21.8572 18.6349 21.9861 18.7639C22.1151 18.8928 22.1875 19.0677 22.1875 19.25V23.9174C22.1875 24.7097 21.9919 25.4896 21.618 26.1881C21.2442 26.8866 20.7037 27.482 20.0446 27.9214L17.7566 29.4477C17.6436 29.5231 17.5108 29.5633 17.375 29.5633C17.2392 29.5633 17.1064 29.5231 16.9934 29.4477L14.7054 27.9214C14.0464 27.482 13.506 26.8868 13.1321 26.1884C12.7583 25.4901 12.5626 24.7102 12.5625 23.9181V19.25ZM13.9375 19.9375V23.9174C13.9376 24.4833 14.0773 25.0405 14.3444 25.5394C14.6115 26.0383 14.9977 26.4636 15.4686 26.7774L17.375 28.05L19.2814 26.7781C19.7523 26.4643 20.1385 26.039 20.4056 25.5401C20.6727 25.0412 20.8124 24.484 20.8125 23.9181V19.9375H13.9375ZM17.1736 25.2361L19.9236 22.4861L18.9514 21.5139L16.6875 23.7779L15.7986 22.8889L14.8264 23.8611L16.2014 25.2361C16.3304 25.3649 16.5052 25.4374 16.6875 25.4374C16.8698 25.4374 17.0446 25.3649 17.1736 25.2361Z"
                                  fill="black"
                                />
                              </svg>
                              &nbsp;No Aminities Found
                            </div>
                          </Col>
                        )}
                      </Row>
                    </div>

                  </Col>
                ) : (
                  ""
                )}
                {safetyHygieneArr.length > 0 ? (
                  <Col lg={12} className="mb-5">

                    <div>
                      <h5 className="mb-3">
                        <b>Safety and Hygiene</b>
                      </h5>
                      <Row>
                        {safetyHygieneArr.length > 0 ? (
                          safetyHygieneArr.map((item) => {
                            return (
                              <Col lg={6} className="mb-2">
                                <div>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="27"
                                    height="33"
                                    viewBox="0 0 27 33"
                                    fill="none"
                                  >
                                    <path
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M7.75 2.75C7.20299 2.75 6.67839 2.9673 6.29159 3.35409C5.9048 3.74089 5.6875 4.26549 5.6875 4.8125H3.625C3.07799 4.8125 2.55339 5.0298 2.16659 5.41659C1.7798 5.80339 1.5625 6.32799 1.5625 6.875V26.125C1.5625 26.672 1.7798 27.1966 2.16659 27.5834C2.55339 27.9702 3.07799 28.1875 3.625 28.1875H11.875V26.8125H3.625C3.44266 26.8125 3.2678 26.7401 3.13886 26.6111C3.00993 26.4822 2.9375 26.3073 2.9375 26.125V6.875C2.9375 6.69266 3.00993 6.5178 3.13886 6.38886C3.2678 6.25993 3.44266 6.1875 3.625 6.1875H5.6875C5.6875 6.73451 5.9048 7.25911 6.29159 7.64591C6.67839 8.0327 7.20299 8.25 7.75 8.25H13.25C13.797 8.25 14.3216 8.0327 14.7084 7.64591C15.0952 7.25911 15.3125 6.73451 15.3125 6.1875H17.375C17.5573 6.1875 17.7322 6.25993 17.8611 6.38886C17.9901 6.5178 18.0625 6.69266 18.0625 6.875V17.1875H19.4375V6.875C19.4375 6.32799 19.2202 5.80339 18.8334 5.41659C18.4466 5.0298 17.922 4.8125 17.375 4.8125H15.3125C15.3125 4.26549 15.0952 3.74089 14.7084 3.35409C14.3216 2.9673 13.797 2.75 13.25 2.75H7.75ZM7.0625 4.8125C7.0625 4.63016 7.13493 4.4553 7.26386 4.32636C7.39279 4.19743 7.56766 4.125 7.75 4.125H13.25C13.4323 4.125 13.6072 4.19743 13.7361 4.32636C13.8651 4.4553 13.9375 4.63016 13.9375 4.8125V6.1875C13.9375 6.36984 13.8651 6.5447 13.7361 6.67364C13.6072 6.80257 13.4323 6.875 13.25 6.875H7.75C7.56766 6.875 7.39279 6.80257 7.26386 6.67364C7.13493 6.5447 7.0625 6.36984 7.0625 6.1875V4.8125ZM9.8125 13.0625V11H11.1875V13.0625H13.25V14.4375H11.1875V16.5H9.8125V14.4375H7.75V13.0625H9.8125ZM12.5625 19.25C12.5625 19.0677 12.6349 18.8928 12.7639 18.7639C12.8928 18.6349 13.0677 18.5625 13.25 18.5625H21.5C21.6823 18.5625 21.8572 18.6349 21.9861 18.7639C22.1151 18.8928 22.1875 19.0677 22.1875 19.25V23.9174C22.1875 24.7097 21.9919 25.4896 21.618 26.1881C21.2442 26.8866 20.7037 27.482 20.0446 27.9214L17.7566 29.4477C17.6436 29.5231 17.5108 29.5633 17.375 29.5633C17.2392 29.5633 17.1064 29.5231 16.9934 29.4477L14.7054 27.9214C14.0464 27.482 13.506 26.8868 13.1321 26.1884C12.7583 25.4901 12.5626 24.7102 12.5625 23.9181V19.25ZM13.9375 19.9375V23.9174C13.9376 24.4833 14.0773 25.0405 14.3444 25.5394C14.6115 26.0383 14.9977 26.4636 15.4686 26.7774L17.375 28.05L19.2814 26.7781C19.7523 26.4643 20.1385 26.039 20.4056 25.5401C20.6727 25.0412 20.8124 24.484 20.8125 23.9181V19.9375H13.9375ZM17.1736 25.2361L19.9236 22.4861L18.9514 21.5139L16.6875 23.7779L15.7986 22.8889L14.8264 23.8611L16.2014 25.2361C16.3304 25.3649 16.5052 25.4374 16.6875 25.4374C16.8698 25.4374 17.0446 25.3649 17.1736 25.2361Z"
                                      fill="black"
                                    />
                                  </svg>
                                  &nbsp;{item.name}
                                </div>
                              </Col>
                            );
                          })
                        ) : (
                          <Col lg={6} className="mb-2">
                            <div>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="27"
                                height="33"
                                viewBox="0 0 27 33"
                                fill="none"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M7.75 2.75C7.20299 2.75 6.67839 2.9673 6.29159 3.35409C5.9048 3.74089 5.6875 4.26549 5.6875 4.8125H3.625C3.07799 4.8125 2.55339 5.0298 2.16659 5.41659C1.7798 5.80339 1.5625 6.32799 1.5625 6.875V26.125C1.5625 26.672 1.7798 27.1966 2.16659 27.5834C2.55339 27.9702 3.07799 28.1875 3.625 28.1875H11.875V26.8125H3.625C3.44266 26.8125 3.2678 26.7401 3.13886 26.6111C3.00993 26.4822 2.9375 26.3073 2.9375 26.125V6.875C2.9375 6.69266 3.00993 6.5178 3.13886 6.38886C3.2678 6.25993 3.44266 6.1875 3.625 6.1875H5.6875C5.6875 6.73451 5.9048 7.25911 6.29159 7.64591C6.67839 8.0327 7.20299 8.25 7.75 8.25H13.25C13.797 8.25 14.3216 8.0327 14.7084 7.64591C15.0952 7.25911 15.3125 6.73451 15.3125 6.1875H17.375C17.5573 6.1875 17.7322 6.25993 17.8611 6.38886C17.9901 6.5178 18.0625 6.69266 18.0625 6.875V17.1875H19.4375V6.875C19.4375 6.32799 19.2202 5.80339 18.8334 5.41659C18.4466 5.0298 17.922 4.8125 17.375 4.8125H15.3125C15.3125 4.26549 15.0952 3.74089 14.7084 3.35409C14.3216 2.9673 13.797 2.75 13.25 2.75H7.75ZM7.0625 4.8125C7.0625 4.63016 7.13493 4.4553 7.26386 4.32636C7.39279 4.19743 7.56766 4.125 7.75 4.125H13.25C13.4323 4.125 13.6072 4.19743 13.7361 4.32636C13.8651 4.4553 13.9375 4.63016 13.9375 4.8125V6.1875C13.9375 6.36984 13.8651 6.5447 13.7361 6.67364C13.6072 6.80257 13.4323 6.875 13.25 6.875H7.75C7.56766 6.875 7.39279 6.80257 7.26386 6.67364C7.13493 6.5447 7.0625 6.36984 7.0625 6.1875V4.8125ZM9.8125 13.0625V11H11.1875V13.0625H13.25V14.4375H11.1875V16.5H9.8125V14.4375H7.75V13.0625H9.8125ZM12.5625 19.25C12.5625 19.0677 12.6349 18.8928 12.7639 18.7639C12.8928 18.6349 13.0677 18.5625 13.25 18.5625H21.5C21.6823 18.5625 21.8572 18.6349 21.9861 18.7639C22.1151 18.8928 22.1875 19.0677 22.1875 19.25V23.9174C22.1875 24.7097 21.9919 25.4896 21.618 26.1881C21.2442 26.8866 20.7037 27.482 20.0446 27.9214L17.7566 29.4477C17.6436 29.5231 17.5108 29.5633 17.375 29.5633C17.2392 29.5633 17.1064 29.5231 16.9934 29.4477L14.7054 27.9214C14.0464 27.482 13.506 26.8868 13.1321 26.1884C12.7583 25.4901 12.5626 24.7102 12.5625 23.9181V19.25ZM13.9375 19.9375V23.9174C13.9376 24.4833 14.0773 25.0405 14.3444 25.5394C14.6115 26.0383 14.9977 26.4636 15.4686 26.7774L17.375 28.05L19.2814 26.7781C19.7523 26.4643 20.1385 26.039 20.4056 25.5401C20.6727 25.0412 20.8124 24.484 20.8125 23.9181V19.9375H13.9375ZM17.1736 25.2361L19.9236 22.4861L18.9514 21.5139L16.6875 23.7779L15.7986 22.8889L14.8264 23.8611L16.2014 25.2361C16.3304 25.3649 16.5052 25.4374 16.6875 25.4374C16.8698 25.4374 17.0446 25.3649 17.1736 25.2361Z"
                                  fill="black"
                                />
                              </svg>
                              &nbsp;No safety and hygiene
                            </div>
                          </Col>
                        )}
                      </Row>
                    </div>

                  </Col>
                ) :
                  ""
                }
              </Col>

              {checkin < checkout ?
                <Col lg={4} className="mb-4">
                  <div>
                    {propertyPurchaseTypeId == 2 ?
                      <Card className="rounded-4">
                        <div className="d-flex justify-content-between border-bottom border-grey p-4 mb-4">
                          <div>
                            <h5 className="mb-0">
                              <b>${isSelectRoomTypes == true ? roomPrice : 0}/night</b>
                            </h5>
                          </div>
                          <div>
                            <Button
                              variant="primary"
                              className="rounded-5"
                              onClick={handleOpenHost}
                              style={{ cursor: "pointer", marginTop: "-10px" }}
                            >
                              Contact Host

                              {/* petsPrice */}
                            </Button>
                          </div>
                        </div>
                        <div className="px-4 pb-4 two_month_date">
                          <Row className="align-items-center">
                            <Col lg={12}>

                              <Button
                                variant=""
                                className="w-100 mb-4 text-black border-dark rounded-5 position-relative"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="18"
                                  height="18"
                                  viewBox="0 0 20 22"
                                  fill="none"
                                >
                                  <path
                                    d="M14.5 7.16H5.5C5.08579 7.16 4.75 7.49579 4.75 7.91C4.75 8.32421 5.08579 8.66 5.5 8.66H14.5C14.9142 8.66 15.25 8.32421 15.25 7.91C15.25 7.49579 14.9142 7.16 14.5 7.16Z"
                                    fill="black"
                                  />
                                  <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M14.89 2.57H15C17.7614 2.57 20 4.80858 20 7.57V16.57C20 19.3314 17.7614 21.57 15 21.57H5C3.67392 21.57 2.40215 21.0432 1.46447 20.1055C0.526784 19.1679 0 17.8961 0 16.57V7.57C0 4.80858 2.23858 2.57 5 2.57H5.09V0.75C5.09 0.335786 5.42579 0 5.84 0C6.25421 0 6.59 0.335786 6.59 0.75V2.57H13.39V0.75C13.39 0.335786 13.7258 0 14.14 0C14.5542 0 14.89 0.335786 14.89 0.75V2.57ZM15 20.07C16.933 20.07 18.5 18.503 18.5 16.57V7.57C18.5 5.637 16.933 4.07 15 4.07H5C3.067 4.07 1.5 5.637 1.5 7.57V16.57C1.5 18.503 3.067 20.07 5 20.07H15Z"
                                    fill="black"
                                  />
                                </svg>
                                &nbsp;

                                {values.slice(0, 1).map((day, index) => (
                                  <>{day.format()}</>
                                ))}
                                -
                                {values.slice(1, 2).map((day, index) => (
                                  <>{day.format()}</>
                                ))}
                                {/* 5 October - 8 October */}
                                <DatePicker
                                  value={values}
                                  minDate={moment().subtract(1, "day").toDate()}
                                  onChange={setValues}
                                  numberOfMonths={2}
                                  range
                                />
                              </Button>

                              <div className="guest_dropdown">
                                <Dropdown>
                                  <Dropdown.Toggle
                                    variant="default"
                                    id="dropdown-basic"
                                    className="w-100 mb-4 text-black border-dark rounded-5"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="18"
                                      height="18"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                    >
                                      <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M19.58 16.71L19.82 17.85C20.0474 18.8356 19.8228 19.8713 19.2076 20.6742C18.5924 21.4771 17.6508 21.9633 16.64 22H7.35997C6.34915 21.9633 5.40754 21.4771 4.79232 20.6742C4.1771 19.8713 3.95254 18.8356 4.17997 17.85L4.41997 16.71C4.69601 15.1668 6.02259 14.0327 7.58997 14H16.41C17.9774 14.0327 19.3039 15.1668 19.58 16.71ZM16.64 20.49C17.1478 20.4841 17.6256 20.2489 17.94 19.85V19.86C18.3257 19.3762 18.4759 18.7458 18.35 18.14L18.11 17C17.9768 16.1552 17.2646 15.5226 16.41 15.49H7.58998C6.73534 15.5226 6.02314 16.1552 5.88998 17L5.64998 18.14C5.52713 18.7426 5.67724 19.3687 6.05998 19.85C6.37431 20.2489 6.85219 20.4841 7.35998 20.49H16.64Z"
                                        fill="black"
                                      />
                                      <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M12.5 12H11.5C9.29082 12 7.49996 10.2092 7.49996 8.00001V5.36001C7.49729 4.46807 7.85043 3.61189 8.48113 2.98119C9.11184 2.35049 9.96802 1.99735 10.86 2.00001H13.14C14.0319 1.99735 14.8881 2.35049 15.5188 2.98119C16.1495 3.61189 16.5026 4.46807 16.5 5.36001V8.00001C16.5 10.2092 14.7091 12 12.5 12ZM10.86 3.50002C9.83271 3.50002 8.99996 4.33277 8.99996 5.36001V8.00001C8.99996 9.38073 10.1192 10.5 11.5 10.5H12.5C13.8807 10.5 15 9.38073 15 8.00001V5.36001C15 4.86671 14.804 4.39361 14.4552 4.0448C14.1064 3.69598 13.6333 3.50002 13.14 3.50002H10.86Z"
                                        fill="black"
                                      />
                                    </svg>
                                    &nbsp;
                                    {/* Guests {parseInt(guestsCount.adults)} */}
                                    {parseInt(guestsCount.adults) == 0
                                      ? "Add Guests"
                                      : "Guests"}
                                    &nbsp;
                                    {parseInt(guestsCount.adults) > 0
                                      ? parseInt(guestsCount.adults)
                                      : ""}
                                    {parseInt(guestsCount.adults) > 0 &&
                                      parseInt(guestsCount.infants) +
                                      parseInt(guestsCount.children) +
                                      parseInt(guestsCount.pets) >
                                      0
                                      ? " , "
                                      : ""}
                                    {parseInt(guestsCount.infants) +
                                      parseInt(guestsCount.children) +
                                      parseInt(guestsCount.pets) ==
                                      0
                                      ? ""
                                      : "Others"}
                                    &nbsp;
                                    {parseInt(
                                      parseInt(guestsCount.infants) +
                                      parseInt(guestsCount.children) +
                                      parseInt(guestsCount.pets)
                                    ) > 0
                                      ? parseInt(
                                        parseInt(guestsCount.infants) +
                                        parseInt(guestsCount.children) +
                                        parseInt(guestsCount.pets)
                                      )
                                      : ""}
                                  </Dropdown.Toggle>

                                  <Dropdown.Menu>
                                    <div className="px-2">
                                      <div className="d-flex justify-content-between align-items-center">
                                        <div>Adults</div>
                                        <div>
                                          <div class="input-group">
                                            <span class="input-group-btn">
                                              <button
                                                name="adults"
                                                onClick={
                                                  (e) => updateGuestCount("minus", "adults")
                                                }
                                                type="button"
                                                class="btn   btn-sm btn-number rounded-5 border border-secondary"
                                              >
                                                <span class="">
                                                  <FontAwesomeIcon
                                                    icon={faMinus}
                                                  />
                                                </span>
                                              </button>
                                            </span>
                                            <input
                                              type="text"
                                              name="guestQuantity"
                                              class="form-control  input-number border-0"
                                              min="1"
                                              max="10"
                                              value={guestsCount.adults}
                                            />
                                            <span class="input-group-btn">
                                              <button
                                                onClick={
                                                  (e) => updateGuestCount("plus", "adults")
                                                }
                                                type="button"
                                                class="btn  btn-sm btn-number rounded-5 border border-secondary"
                                              >
                                                <span class="">
                                                  <FontAwesomeIcon
                                                    icon={faPlus}
                                                  />
                                                </span>
                                              </button>
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="d-flex justify-content-between align-items-center">
                                        <div>Children</div>
                                        <div>
                                          <div class="input-group">
                                            <span class="input-group-btn">
                                              <button
                                                type="button"
                                                name="children"
                                                onClick={
                                                  (e) => updateGuestCount("minus", "children")
                                                }
                                                class="btn   btn-sm btn-number rounded-5 border border-secondary"
                                                data-type="plus"
                                                data-field="quant[1]"
                                              >
                                                <span class="">
                                                  <FontAwesomeIcon
                                                    icon={faMinus}
                                                  />
                                                </span>
                                              </button>
                                            </span>
                                            <input
                                              type="text"
                                              name="guestQuantity"
                                              class="form-control  input-number border-0"
                                              min="1"
                                              max="10"
                                              value={guestsCount.children}
                                            />
                                            <span class="input-group-btn">
                                              <button
                                                type="button"
                                                name="children"
                                                onClick={
                                                  (e) => updateGuestCount("plus", "children")
                                                }
                                                class="btn  btn-sm btn-number rounded-5 border border-secondary"
                                                data-type="minus"
                                                data-field="quant[1]"
                                              >
                                                <span class="">
                                                  <FontAwesomeIcon
                                                    icon={faPlus}
                                                  />
                                                </span>
                                              </button>
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="d-flex justify-content-between align-items-center">
                                        <div>Infants</div>
                                        <div>
                                          <div class="input-group">
                                            <span class="input-group-btn">
                                              <button
                                                name="infants"
                                                onClick={(e) =>
                                                  setguestCount((old) => {
                                                    return {
                                                      ...old,
                                                      ["infants"]:
                                                        parseInt(
                                                          guestsCount.infants
                                                        ) -
                                                          1 <
                                                          0
                                                          ? 0
                                                          : parseInt(
                                                            guestsCount.infants
                                                          ) - 1,
                                                    };
                                                  })
                                                }
                                                type="button"
                                                class="btn   btn-sm btn-number rounded-5 border border-secondary"
                                                data-type="plus"
                                                data-field="quant[1]"
                                              >
                                                <span class="">
                                                  <FontAwesomeIcon
                                                    icon={faMinus}
                                                  />
                                                </span>
                                              </button>
                                            </span>
                                            <input
                                              type="text"
                                              name="guestQuantity"
                                              class="form-control  input-number border-0"
                                              min="1"
                                              max="10"
                                              value={guestsCount.infants}
                                            />
                                            <span class="input-group-btn">
                                              <button
                                                name="infants"
                                                onClick={(e) =>
                                                  setguestCount((old) => {
                                                    return {
                                                      ...old,
                                                      ["infants"]:
                                                        parseInt(
                                                          guestsCount.infants
                                                        ) + 1,
                                                    };
                                                  })
                                                }
                                                type="button"
                                                class="btn  btn-sm btn-number rounded-5 border border-secondary"
                                                data-type="minus"
                                                data-field="quant[1]"
                                              >
                                                <span class="">
                                                  <FontAwesomeIcon
                                                    icon={faPlus}
                                                  />
                                                </span>
                                              </button>
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="d-flex justify-content-between align-items-center">
                                        <div>Pets</div>
                                        <div>
                                          <div class="input-group">
                                            <span class="input-group-btn">
                                              <button
                                                type="button"
                                                name="pets"
                                                onClick={(e) =>
                                                  setguestCount((old) => {
                                                    return {
                                                      ...old,
                                                      ["pets"]:
                                                        parseInt(
                                                          guestsCount.pets
                                                        ) -
                                                          1 <
                                                          0
                                                          ? 0
                                                          : parseInt(
                                                            guestsCount.pets
                                                          ) - 1,
                                                    };
                                                  })
                                                }
                                                class="btn   btn-sm btn-number rounded-5 border border-secondary"
                                                data-type="plus"
                                                data-field="quant[1]"
                                              >
                                                <span class="">
                                                  <FontAwesomeIcon
                                                    icon={faMinus}
                                                  />
                                                </span>
                                              </button>
                                            </span>
                                            <input
                                              type="text"
                                              name="guestQuantity"
                                              class="form-control  input-number border-0"
                                              min="1"
                                              max="10"
                                              value={guestsCount.pets}
                                            />
                                            <span class="input-group-btn">
                                              <button
                                                type="button"
                                                class="btn  btn-sm btn-number rounded-5 border border-secondary"
                                                data-type="minus"
                                                name="pets"
                                                onClick={(e) =>
                                                  setguestCount((old) => {
                                                    return {
                                                      ...old,
                                                      ["pets"]:
                                                        parseInt(
                                                          guestsCount.pets
                                                        ) + 1,
                                                    };
                                                  })
                                                }
                                                data-field="quant[1]"
                                              >
                                                <span class="">
                                                  <FontAwesomeIcon
                                                    icon={faPlus}
                                                  />
                                                </span>
                                              </button>
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </Dropdown.Menu>
                                </Dropdown>
                              </div>
                            </Col>
                            <Col lg={12} className="mb-3">
                              <div className="mb-3">

                                {/* <div className="d-flex justify-content-between text-grey border-bottom p-2">
                                  <div>
                                    {" "}
                                    {parseFloat(guestsCount.adults) / 2 -
                                      parseInt(guestsCount.adults / 2) >
                                      0
                                      ? parseInt(
                                        parseFloat(guestsCount.adults) / 2
                                      ) + 1
                                      : parseFloat(guestsCount.adults) / 2}{" "}
                                    Beds X {parseFloat(roomPrice)} $
                                    X {totalBookingDay} Nights
                                  </div>
                                  <div className="text-right">
                                    $
                                    {(parseFloat(guestsCount.adults) / 2 -
                                      parseInt(guestsCount.adults / 2) >
                                      0
                                      ? parseInt(
                                        parseFloat(guestsCount.adults) / 2
                                      ) + 1
                                      : parseFloat(guestsCount.adults) / 2) *
                                      parseFloat(roomPrice) *
                                      totalBookingDay}
                                  </div>
                                </div> */}

                                {parseInt(guestsCount.pets) > 0 ? <div className="d-flex justify-content-between text-grey border-bottom">

                                  <div>Pets Charges</div>
                                  <div className="text-right">+ ${parseInt(guestsCount.pets) * parseFloat(propertyDetail?.petsPrice)} </div>
                                </div> : ""}

                                <div className="d-flex justify-content-between text-grey border-bottom p-2">
                                  <div>Cleaning and service fee</div>
                                  <div className="text-right">+ ${propertyDetail?.cleaningAndMaintenanceFee ? propertyDetail?.cleaningAndMaintenanceFee : 0}</div>
                                </div>
                                <div className="d-flex justify-content-between text-grey border-bottom p-2">
                                  <div>Taxes</div>
                                  <div className="text-right">+ ${propertyDetail?.taxPercentage ?
                                    ((parseFloat(guestsCount.adults) / 2 -
                                      parseInt(guestsCount.adults / 2) >
                                      0
                                      ? parseInt(
                                        parseFloat(guestsCount.adults) / 2
                                      ) + 1
                                      : parseFloat(guestsCount.adults) / 2) *
                                      parseFloat(roomPrice) *
                                      totalBookingDay) * parseFloat(propertyDetail?.taxPercentage) / 100
                                    : 0}</div>
                                </div>
                                <div className="d-flex justify-content-between text-grey ">
                                  {propertyDetail?.cancellationPercentage ?
                                    <div className="d-flex justify-content-between text-grey border-bottom p-2">
                                      <div>Booking Cancellation Charges</div>
                                      <div className="text-right">{propertyDetail?.cancellationPercentage}%</div>
                                    </div>
                                    : ""}
                                </div>
                                <div className="d-flex justify-content-between text-grey border-bottom p-2">
                                  <div>Security Deposit</div>
                                  <div className="text-right">+ ${propertyDetail?.securityDeposit ? propertyDetail?.securityDeposit : 0}</div>
                                </div>
                                <div className="d-flex justify-content-between p-2">
                                  <div className="fw-bold">Total {totalBookingDay}-night stay</div>
                                  <div className="text-right fw-bold">
                                    $
                                    {
                                      (() => {
                                        const totalGuests = parseInt(guestsCount.adults) + parseInt(guestsCount.children);
                                        const roomsNeeded =
                                          Math.ceil(totalGuests / guestCountPerRoom);
                                        const baseRoomCost = parseFloat(roomsNeeded) * parseFloat(roomPrice) * parseFloat(totalBookingDay);

                                        const tax =
                                          propertyDetail?.taxPercentage
                                            ? (Math.ceil(totalGuests / 2) * roomPrice * totalBookingDay * propertyDetail.taxPercentage) / 100
                                            : 0;

                                        const cleaningFee =
                                          propertyDetail?.cleaningAndMaintenanceFee && totalGuests > 0
                                            ? parseFloat(propertyDetail.cleaningAndMaintenanceFee)
                                            : 0;

                                        const petsCost =
                                          propertyDetail?.petsPrice && guestsCount.pets > 0
                                            ? guestsCount.pets * parseFloat(propertyDetail.petsPrice)
                                            : 0;

                                        const securityDeposit = parseFloat(propertyDetail?.securityDeposit || 0);

                                        const totalAmount =
                                          baseRoomCost + tax + cleaningFee + petsCost + securityDeposit;

                                        return totalAmount.toLocaleString(undefined, {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        });
                                      })()
                                    }

                                  </div>
                                </div>

                              </div>
                              <p style={{ color: 'red', fontSize: '13px' }}> Note: Security Deposit Charges is refundable if there is no damages. </p>
                              <Button
                                variant="primary"
                                className="w-100 rounded-5"
                                onClick={(e) => bookHandler(e)}
                              >
                                Reserve Now
                              </Button>
                            </Col>
                          </Row>
                        </div>
                      </Card>
                      : ""}
                    {propertyPurchaseTypeId == 1 ? (
                      <Card className="rounded-4">
                        <div className="border-bottom border-grey p-4 mb-4 text-center">
                          <div>
                            <h5 className="mb-0 text-blue">
                              <b>{propertyDetail.propertyName}</b>
                            </h5>
                          </div>
                        </div>
                        <div className="px-4 pb-4 two_month_date">
                          <Row className="align-items-center">
                            <Col lg={12} className="mb-3">
                              <div className="text-center mt-2 mb-4">
                                <h5>
                                  $
                                  {propertyDetail.propertyPurchaseTypeId == 1 ? (
                                    <b>{propertyDetail.price.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b>
                                  ) : (
                                    ""
                                  )}
                                  {propertyDetail.propertyPurchaseTypeId == 3 ? (
                                    <b>
                                      {propertyDetail.priceType == 1
                                        ? `${propertyDetail.price.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}/year`
                                        : `${propertyDetail.price.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}/month`}
                                    </b>
                                  ) : (
                                    ""
                                  )}
                                </h5>

                              </div>
                              <Button
                                variant="default"
                                className="w-100 rounded-5 mb-2 border border-dark"
                                onClick={handleOpenHost}
                              >
                                Contact Host
                              </Button>
                              <Button
                                variant="primary"
                                className="w-100 rounded-5"
                                onClick={(e) => bookHandler1(e)}
                              >
                                Buy Now
                              </Button>
                            </Col>
                          </Row>
                        </div>
                      </Card>
                    ) : (
                      ""
                    )}

                    {propertyPurchaseTypeId == 3 ? (
                      <Card className="rounded-4">
                        <div className="border-bottom border-grey p-4 mb-4 text-center">
                          <div>
                            <h5 className="mb-0 text-blue">
                              <b>{propertyDetail.propertyName}</b>
                            </h5>
                          </div>
                        </div>
                        <div className="px-4 pb-4 two_month_date">
                          <Row className="align-items-center">
                            <Col lg={12} className="mb-3">
                              <div className="text-center mt-2 mb-4">
                                <h5>
                                  $
                                  {propertyDetail.propertyPurchaseTypeId == 1 ? (
                                    <b>{propertyDetail.price}</b>
                                  ) : (
                                    ""
                                  )}
                                  {propertyDetail.propertyPurchaseTypeId == 3 ? (
                                    <b>
                                      {propertyDetail.priceType == 1
                                        ? `${propertyDetail.price}/year`
                                        : `${propertyDetail.price}/month`}
                                    </b>
                                  ) : (
                                    ""
                                  )}
                                </h5>
                                <div className="d-flex justify-content-between align-items-center">
                                  <div>
                                    Select No. of{" "}
                                    {propertyDetail.priceType == 1
                                      ? "Years"
                                      : "Months"}
                                  </div>
                                  <div>
                                    <div class="input-group">
                                      <span class="input-group-btn">
                                        <button
                                          name={
                                            propertyDetail.priceType
                                              ? "years"
                                              : "months"
                                          }
                                          onClick={(e) =>
                                            setleaseCount((old) => {
                                              return {
                                                ...old,
                                                [propertyDetail.priceType
                                                  ? "years"
                                                  : "months"]:
                                                  parseInt(
                                                    leaseCount[
                                                    propertyDetail.priceType
                                                      ? "years"
                                                      : "months"
                                                    ]
                                                  ) -
                                                    1 <
                                                    1
                                                    ? 1
                                                    : parseInt(
                                                      leaseCount[
                                                      propertyDetail.priceType
                                                        ? "years"
                                                        : "months"
                                                      ]
                                                    ) - 1,
                                              };
                                            })
                                          }
                                          type="button"
                                          class="btn   btn-sm btn-number rounded-5 border border-secondary"
                                        >
                                          <span class="">
                                            <FontAwesomeIcon icon={faMinus} />
                                          </span>
                                        </button>
                                      </span>
                                      <input
                                        type="text"
                                        name="guestQuantity"
                                        class="form-control  input-number border-0"
                                        min="1"
                                        max="10"
                                        value={
                                          leaseCount[
                                          propertyDetail.priceType
                                            ? "years"
                                            : "months"
                                          ]
                                        }
                                      />
                                      <span class="input-group-btn">
                                        <button
                                          onClick={(e) =>
                                            setleaseCount((old) => {
                                              return {
                                                ...old,
                                                [propertyDetail.priceType
                                                  ? "years"
                                                  : "months"]:
                                                  parseInt(
                                                    leaseCount[
                                                    propertyDetail.priceType
                                                      ? "years"
                                                      : "months"
                                                    ]
                                                  ) + 1,
                                              };
                                            })
                                          }
                                          type="button"
                                          class="btn  btn-sm btn-number rounded-5 border border-secondary"
                                        >
                                          <span class="">
                                            <FontAwesomeIcon icon={faPlus} />
                                          </span>
                                        </button>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="mb-3">

                                <div className="d-flex justify-content-between text-grey border-bottom p-2">
                                  <div>
                                    {" "}
                                    ${propertyDetail.price}X{" "}
                                    {parseInt(
                                      leaseCount[
                                      propertyDetail.priceType
                                        ? "years"
                                        : "months"
                                      ]
                                    )}{" "}
                                    {[
                                      propertyDetail.priceType
                                        ? "years"
                                        : "months",
                                    ]}{" "}
                                  </div>
                                  <div className="text-right">
                                    $
                                    {propertyDetail.price *
                                      parseInt(
                                        leaseCount[
                                        propertyDetail.priceType
                                          ? "years"
                                          : "months"
                                        ]
                                      )}
                                  </div>
                                </div>
                                <div className="d-flex justify-content-between text-grey border-bottom p-2">
                                  <div>Cleaning and service fee</div>
                                  <div className="text-right">+ ${propertyDetail?.cleaningAndMaintenanceFee ? propertyDetail?.cleaningAndMaintenanceFee : 0}</div>
                                </div>
                                <div className="d-flex justify-content-between text-grey border-bottom p-2">
                                  <div>Taxes</div>
                                  <div className="text-right">+ ${propertyDetail?.taxPercentage ?
                                    (propertyDetail.price *
                                      parseInt(
                                        leaseCount[
                                        propertyDetail.priceType
                                          ? "years"
                                          : "months"
                                        ]
                                      )) * parseFloat(propertyDetail?.taxPercentage) / 100
                                    : 0}</div>
                                </div>
                                <div className="d-flex justify-content-between text-grey border-bottom p-2">
                                  <div>Security Deposit</div>
                                  <div className="text-right">+ ${propertyDetail?.securityDeposit ? propertyDetail?.securityDeposit : 0}</div>
                                </div>
                                <div className="d-flex justify-content-between fw-bold p-2">
                                  <div>
                                    Total{" "}
                                    {parseInt(
                                      leaseCount[
                                      propertyDetail.priceType
                                        ? "years"
                                        : "months"
                                      ]
                                    )}
                                    -
                                    {[
                                      propertyDetail.priceType
                                        ? "years"
                                        : "months",
                                    ]}
                                  </div>
                                  <div className="text-right">
                                    $
                                    {parseFloat(propertyDetail?.cleaningAndMaintenanceFee ?? 0) +
                                      parseFloat(propertyDetail?.securityDeposit ?? 0) +
                                      (parseFloat(propertyDetail.price) * parseInt(leaseCount[propertyDetail.priceType ? "years" : "months"]) +
                                        (parseFloat(propertyDetail.price) * parseInt(leaseCount[propertyDetail.priceType ? "years" : "months"])) * parseFloat(propertyDetail?.taxPercentage ?? 0) / 100)}
                                  </div>
                                </div>

                              </div>
                              <p style={{ color: 'red', fontSize: '13px' }}> Note: Security Deposit Charges is refundable if there is no damages. </p>
                              <Button
                                variant="default"
                                className="w-100 rounded-5 mb-2 border border-dark"
                                onClick={handleOpenHost}
                              >
                                Contact Host
                              </Button>
                              <Button
                                variant="primary"
                                className="w-100 rounded-5"
                                onClick={(e) => bookHandler(e)}
                              >
                                Buy Now
                              </Button>
                            </Col>
                          </Row>
                        </div>
                      </Card>
                    ) : (
                      ""
                    )}
                  </div>
                </Col>
                :
                <Col lg={4} className="mb-4">
                  <div>
                    <Card className="rounded-4">
                      <div className="d-flex justify-content-between border-grey p-4 mb-4">
                        <div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="38"
                            height="38"
                            viewBox="0 0 38 38"
                            fill="none"
                          >
                            <circle
                              cx="19"
                              cy="19"
                              r="17"
                              stroke="#E46422"
                              stroke-width="3"
                            />
                            <path
                              d="M19 12.2V18.7324C19 18.8995 19.0836 19.0557 19.2226 19.1484L24.1 22.4"
                              stroke="#E46422"
                              stroke-width="3"
                              stroke-linecap="round"
                            />
                          </svg>
                          <h5 className="mt-2"><b>Not Available!</b></h5>
                          <span>
                            {propertyDetail?.propertyName} is not available for {checkin} - {checkout}
                          </span>
                        </div>
                      </div>
                    </Card>
                  </div>
                </Col>
              }
            </Row>

            <Row>
              {propertyDetail?.getPropertyRoomTypeImages?.length == 0 || propertyDetail?.getPropertyRoomTypeImages == null && propertyDetail?.getPropertyRoomTypeImages == undefined ?
                "" :
                <>
                  <hr />
                  <Col lg={12} className="">
                    <h5 className="mb-3">
                      <b>Room Types</b>
                    </h5>
                    <div>
                      <Row>
                        {propertyDetail?.getPropertyRoomTypeImages.map(roomImg => (
                          <Col lg={4} className="my-3">
                            <h6 className="mb-3" style={{height:'38px'}}>
                              <b>{roomImg.roomName} Room ({roomImg.personsAllowed} Guests/Per Room)</b>
                            </h6>
                            <Card className="border-0">
                              <div class="post-image-card position-relative">
                                <div class="rounded-2 bg-black overflow-hidden">
                                  <img
                                    class="card-img-top opacity-75"
                                    src={roomImg.fileName}
                                    style={{ width: "100%", height: "250px" }}
                                  />
                                </div>
                                <div className="image-h ">
                                  <button type="button" class="viewmore position-absolute rounded-2 btn-sm h-auto text-white border btn btn-default" onClick={() => handleOpenviewImages(roomImg, roomImg.roomName)}>View More</button>
                                </div>

                              </div>
                              {propertyPurchaseTypeId == 2 ?
                                <>
                                  <Card.Body>
                                    <div className="d-md-flex justify-content-between">
                                      <h5>${roomImg.price ? parseFloat(roomImg.price).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0.00"}</h5>
                                      <button type="button" class={roomType.current == roomImg.roomTypeId ? "btn btn-primary border rounded-5" : "btn btn-light border rounded-5"} onClick={() => selectRoomType(roomImg.price, roomImg.roomTypeId, roomImg.personsAllowed)}>Select Room</button>
                                    </div>
                                  </Card.Body>
                                </>
                                : ""}
                            </Card>
                          </Col>
                        ))}
                      </Row>
                    </div>
                  </Col>
                  <hr />
                </>
              }

              {!propertyDetail.propertyVideo ||
                propertyDetail.propertyVideo == null ||
                propertyDetail.propertyVideo == undefined ?
                "" :
                <Col lg={12} className="mb-3">
                  <div>
                    <h5 className="mb-3">
                      <b>Property Video </b>
                    </h5>
                    <Row>
                      <Col lg="6">
                        <video width="300" controls>
                          <source
                            src={
                              propertyDetail.propertyVideo
                            }
                          />
                        </video>
                        <br />
                        <br />
                        <a
                          href={
                            propertyDetail.propertyVideo
                          }
                          target="_blank"
                        >
                          <Button
                            variant="primary"
                            className="btn btn-primary border rounded-5"
                          >
                            View Video
                          </Button>
                        </a>
                      </Col>
                    </Row>
                  </div>
                </Col>
              }

              {propertyDetail?.cancellationAdditionalRules ?
                <Col lg={12} className="mb-5">
                  <div>
                    <h5 className="mb-3">
                      <b>Booking Cancellation Policies</b>
                    </h5>
                    <Row>
                      <Col lg={12} className="mb-2">
                        <p className="text-grey">
                          {propertyDetail?.cancellationAdditionalRules}
                        </p>
                      </Col>
                    </Row>
                  </div>
                </Col>
                : ""}

              {propertyDetail.ratingArr == null ?
                "" :
                <Col lg={12} className="mb-5 mt-4">
                  <div>
                    <h5 className="mb-3 d-flex align-items-center ">
                      <b className="me-2">Reviews</b> &nbsp;
                      <span className="d-flex align-items-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                        >
                          <path
                            d="M19.9471 7.18026C19.8843 6.99515 19.7686 6.8325 19.6143 6.71238C19.4601 6.59227 19.274 6.51995 19.0791 6.50435L13.3781 6.05141L10.9111 0.591133C10.8325 0.415269 10.7047 0.265898 10.5431 0.161048C10.3815 0.0561979 10.193 0.000350006 10.0004 0.000244291C9.80777 0.000138576 9.61922 0.0557796 9.45751 0.160452C9.2958 0.265125 9.16784 0.414356 9.08908 0.590134L6.62206 6.05141L0.921032 6.50435C0.729486 6.51952 0.546368 6.58955 0.393584 6.70605C0.2408 6.82256 0.12482 6.98061 0.0595198 7.16129C-0.00578041 7.34198 -0.017636 7.53765 0.0253714 7.72489C0.0683787 7.91214 0.164428 8.08303 0.302028 8.21712L4.51505 12.3236L3.02504 18.7747C2.9798 18.97 2.9943 19.1744 3.06666 19.3613C3.13903 19.5482 3.26591 19.7091 3.43085 19.823C3.59579 19.937 3.79117 19.9987 3.99163 20.0002C4.1921 20.0017 4.3884 19.943 4.55505 19.8316L10.0001 16.2021L15.4451 19.8316C15.6155 19.9447 15.8163 20.0029 16.0208 19.9984C16.2252 19.9939 16.4233 19.9269 16.5885 19.8065C16.7537 19.6861 16.8781 19.5179 16.9449 19.3247C17.0117 19.1315 17.0177 18.9225 16.9621 18.7257L15.1331 12.3266L19.6691 8.24512C19.9661 7.97715 20.0751 7.55921 19.9471 7.18026Z"
                            fill="#E46422"
                          />
                        </svg>{" "}
                        &nbsp;
                        <span className="text-primary">
                          {" "}
                          {propertyDetail.ratingArr == null
                            ? "0"
                            : parseFloat(
                              JSON.parse(propertyDetail.ratingArr)
                                .map((items) => items.ratings)
                                .reduce((prev, next) => prev + next) /
                              JSON.parse(propertyDetail.ratingArr).length
                            ).toFixed(1)}
                        </span>
                      </span>
                    </h5>
                  </div>
                </Col>
              }

              {propertyDetail.ratingArr == null
                ? ""
                :
                <Col lg={12} className="mb-5">
                  <div>
                    <Row>
                      {JSON.parse(propertyDetail.ratingArr).map((items, i) => {
                        return (
                          i < 6 ?
                            <Col lg={4} className="mb-3">
                              <div className="d-flex align-items-center mb-2">
                                <img
                                  src={
                                    items.ratingUserProfile == null ||
                                      items.ratingUserProfile == ""
                                      ? "assets/images/profile-img.png"
                                      : `${items.ratingUserProfile}`
                                  }
                                  className="me-3 reviewImg"
                                  alt="Rating"
                                />
                                <div>
                                  <h6 className="mb-0">
                                    <b>{items.ratingUserName}</b>
                                  </h6>
                                  <p>
                                    <div className="d-flex align-items-center">
                                      <div className="rating_star">
                                        <FaStar
                                          className="me-1"
                                          fill={
                                            items.ratings >= 1
                                              ? "rgb(228, 100, 34)"
                                              : "#b5b0b0"
                                          }
                                        />
                                        <FaStar
                                          className="me-1"
                                          fill={
                                            items.ratings >= 2
                                              ? "rgb(228, 100, 34)"
                                              : "#b5b0b0"
                                          }
                                        />
                                        <FaStar
                                          className="me-1"
                                          fill={
                                            items.ratings >= 3
                                              ? "rgb(228, 100, 34)"
                                              : "#b5b0b0"
                                          }
                                        />
                                        <FaStar
                                          className="me-1"
                                          fill={
                                            items.ratings >= 4
                                              ? "rgb(228, 100, 34)"
                                              : "#b5b0b0"
                                          }
                                        />{" "}
                                        <FaStar
                                          className="me-1"
                                          fill={
                                            items.ratings >= 5
                                              ? "rgb(228, 100, 34)"
                                              : "#b5b0b0"
                                          }
                                        />
                                      </div>
                                      {/* &nbsp;<b>{items.ratings}</b> */}
                                    </div>
                                  </p>
                                  <p className="text-grey mb-0">
                                    {moment(items.createdDate).format("ll")}
                                  </p>
                                </div>
                              </div>
                              <p className="text-grey">{items.review.length > 100 ?
                                <>
                                  {items.review.toString().substring(0, 100)}
                                  .....<span onClick={handleOpenReviewRating} className="reviewRatingShowMore">Show more</span>
                                </>
                                : items.review}</p>
                            </Col>
                            : ""
                        );
                      })}
                    </Row>

                    {propertyDetail.ratingArr == null ?
                      "" :
                      JSON.parse(propertyDetail.ratingArr).length > 6 ?

                        <>
                          <Button
                            variant="primary"
                            className="rounded-3"
                            onClick={handleOpenReviewRating}
                            style={{ cursor: "pointer", marginTop: "-10px" }}
                          >
                            Show all {JSON.parse(propertyDetail.ratingArr).length} reviews
                          </Button>
                        </>

                        : ""
                    }

                  </div>
                </Col>
              }

            </Row>
          </Container>
        </div>
        <div style={{ width: "100%" }}>
          <Maps selectedLocation={selectedLocation} />
        </div>
        <hr className="mt-0" />
      </section>

      {/* Send Request to host  */}
      <Modal
        show={isHostRequestOpen}
        onHide={() => handleCloseHost(false)}
        dialogClassName="modal-90w modal-right"
        aria-labelledby="example-custom-modal-styling-title"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <b>Contact Host</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex align-items-center">
            <div className="me-2">
              {!propertyDetail?.profile ||
                propertyDetail?.profile == null ||
                propertyDetail?.profile == undefined ? (
                <img
                  src="assets/images/profile-img.png"
                  height={`62px`}
                  width={`100px`}
                  className="object-fit-contain rounded-2"
                />
              ) : (
                <img
                  src={propertyDetail?.profile}
                  height={`62px`}
                  width={`100px`}
                  className="object-fit-contain rounded-2"
                />
              )}
            </div>
            <div>
              <p className="mb-0">{propertyDetail?.firstName}</p>
              <span style={{ fontSize: "12px" }}>
                Typically responds within an hour
              </span>
            </div>
          </div>
          <br />
          <Formik
            initialValues={{
              title: "",
              message: "",
            }}
            validationSchema={AddTicketSchema}
            onSubmit={(values) => {
              formSubmit(values);
            }}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              touched,
              values,
            }) => (
              <>
                <Form onSubmit={handleSubmit}>
                  <Form.Group
                    className="mb-4"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label>Title</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Title"
                      onChange={handleChange}
                      name="title"
                      value={values.title}
                    />
                    <span className="text-danger">
                      {errors.title && touched.title ? (
                        <div>{errors.title}</div>
                      ) : null}
                    </span>
                  </Form.Group>

                  <Form.Group
                    className="mb-4"
                    controlId="exampleForm.ControlTextarea1"
                  >
                    <Form.Label>Message</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={6}
                      className="h-auto"
                      placeholder="Type your message here"
                      onChange={handleChange}
                      name="message"
                      value={values.message}
                    />
                    <span className="text-danger">
                      {errors.message && touched.message ? (
                        <div>{errors.message}</div>
                      ) : null}
                    </span>
                  </Form.Group>

                  <div className="text-right">
                    <Button
                      variant="primary"
                      className="h-auto rounded-1"
                      type="submit"
                    >
                      Submit
                    </Button>
                  </div>
                </Form>
              </>
            )}
          </Formik>
        </Modal.Body>
      </Modal>

      <Modal
        show={isViewOpen}
        onHide={() => handleCloseview(false)}
        dialogClassName="modal-90w modal-right "
        aria-labelledby="example-custom-modal-styling-title"
        className="hotelImages"
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <b>{propertyDetail.propertyName}</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <>
            <Swiper
              pagination={{
                type: "fraction",
              }}
              navigation={true}
              modules={[Pagination, Navigation]}
              className="mySwiper"
            >
              {imagesArr && imagesArr.length > 0
                ? imagesArr.map((obj) => {
                  return (
                    <SwiperSlide>
                      <img src={obj.fileNameImage} />
                    </SwiperSlide>
                  );
                })
                : ""}
            </Swiper>
          </>
        </Modal.Body>
      </Modal>

      <Modal
        show={isViewOpenImages}
        onHide={() => handleCloseview(false)}
        dialogClassName="modal-90w modal-right "
        aria-labelledby="example-custom-modal-styling-title"
        className="hotelImages"
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <b>{roomName ? roomName : ''} Room</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <>
            <Swiper
              pagination={{
                type: "fraction",
              }}
              navigation={true}
              modules={[Pagination, Navigation]}
              className="mySwiper"
            >
              {roomTypeImages && roomTypeImages.length > 0
                ? roomTypeImages.map((obj) => {
                  return (
                    <SwiperSlide>
                      <img src={obj.fileNameImage} />
                    </SwiperSlide>
                  );
                })
                : ""}
            </Swiper>
          </>
        </Modal.Body>
      </Modal>

      <Modal
        show={isReviewRatingModel}
        onHide={() => handleCloseReviewRating(false)}
        dialogClassName="modal-90w modal-right "
        aria-labelledby="example-custom-modal-styling-title"
        className="hotelImages"
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <b>{propertyDetail.ratingArr == null ?
              "" :
              JSON.parse(propertyDetail.ratingArr).length
            } Reviews</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Col lg={12} className="mb-5 reviewPopup">
            <div>
              <Row>
                {propertyDetail.ratingArr == null
                  ? ""
                  : JSON.parse(propertyDetail.ratingArr).map((items) => {
                    return (
                      <Col lg={12} className="mb-3">
                        <div className="d-flex align-items-center mb-2">
                          <img
                            src={
                              items.ratingUserProfile == null ||
                                items.ratingUserProfile == ""
                                ? "assets/images/profile-img.png"
                                : `${items.ratingUserProfile}`
                            }
                            className="me-3 reviewImg"
                            alt="Rating"
                          />
                          <div>
                            <h6 className="mb-0">
                              <b>{items.ratingUserName}</b>
                            </h6>
                            <p>
                              <div className="d-flex align-items-center">
                                <div className="rating_star">
                                  <FaStar
                                    className="me-1"
                                    fill={
                                      items.ratings >= 1
                                        ? "rgb(228, 100, 34)"
                                        : "#b5b0b0"
                                    }
                                  />
                                  <FaStar
                                    className="me-1"
                                    fill={
                                      items.ratings >= 2
                                        ? "rgb(228, 100, 34)"
                                        : "#b5b0b0"
                                    }
                                  />
                                  <FaStar
                                    className="me-1"
                                    fill={
                                      items.ratings >= 3
                                        ? "rgb(228, 100, 34)"
                                        : "#b5b0b0"
                                    }
                                  />
                                  <FaStar
                                    className="me-1"
                                    fill={
                                      items.ratings >= 4
                                        ? "rgb(228, 100, 34)"
                                        : "#b5b0b0"
                                    }
                                  />{" "}
                                  <FaStar
                                    className="me-1"
                                    fill={
                                      items.ratings >= 5
                                        ? "rgb(228, 100, 34)"
                                        : "#b5b0b0"
                                    }
                                  />
                                </div>
                                &nbsp;<b>{items.ratings}</b>
                              </div>
                            </p>
                            <p className="text-grey mb-0">
                              {moment(items.createdDate).format("ll")}
                            </p>
                          </div>
                        </div>
                        <p className="text-grey">{items.review}</p>
                      </Col>
                    );
                  })}
              </Row>
            </div>
          </Col>
        </Modal.Body>
      </Modal>

      <Footer />
    </>
  );
};

export default PropertyDetails;
